import { createSlice } from '@reduxjs/toolkit';

export const helpSlice = createSlice({
	name: 'help',
	initialState: {
		show: false,
	},
	reducers: {
		toggle: state => {
			// Redux Toolkit allows us to write "mutating" logic in reducers. It
			// doesn't actually mutate the state because it uses the Immer library,
			// which detects changes to a "draft state" and produces a brand new
			// immutable state based off those changes.
			// Also, no return statement is required from these functions.
			state.show = !state.show;
		},
	},
});

// Action creators are generated for each case reducer function
export const { toggle } = helpSlice.actions;

export default helpSlice.reducer;
